/**
 * Shared Sentry beforeSend filters for browser apps.
 */

const DROPPED_MESSAGE_FRAGMENTS = [
  "ResizeObserver loop limit exceeded",
  "Non-Error promise rejection captured",
  "ChunkLoadError",
  "Loading chunk",
  "Loading CSS chunk",
  "Error: Rejected",
  "Geolocation error",
  "GeolocationPositionError",
  "User denied Geolocation",
  "User denied geolocation",
  "SecurityError: Failed to register a ServiceWorker",
  "An SSL certificate error occurred",
  "Importing a module script failed",
  "Google Maps API key not configured",
  "Failed to initialize Google Address Autocomplete",
  "Google Maps Places API not available",
  "No geometry found for selected place",
  "Service account credentials not configured",
  "Authentication failed: Service account credentials",
  "Name and phone are required fields",
  "Rate limit exceeded",
  "Too many requests",
];

const DROPPED_URL_FRAGMENTS = [
  "/api/v2/cmdb/",
  "maps.googleapis.com",
];

function eventMessage(event, hint) {
  const error = hint?.originalException;
  return [
    error?.message,
    event?.message,
    event?.logentry?.message,
    event?.exception?.values?.[0]?.value,
  ]
    .filter(Boolean)
    .join(" ");
}

export function shouldDropBrowserSentryEvent(event, hint) {
  const message = eventMessage(event, hint);
  const url = event?.request?.url || "";

  if (
    DROPPED_MESSAGE_FRAGMENTS.some((fragment) => message.includes(fragment))
  ) {
    return true;
  }

  if (DROPPED_URL_FRAGMENTS.some((fragment) => url.includes(fragment))) {
    return true;
  }

  const httpStatus = Number(event?.tags?.httpStatus);
  if (!Number.isNaN(httpStatus) && httpStatus > 0 && httpStatus < 500) {
    return true;
  }

  return false;
}

export function shouldReportLogToSentry(firstArg, context = {}) {
  if (context.reportToSentry === true) return true;
  if (context.reportToSentry === false) return false;

  const status = context.status ?? context.statusCode;
  if (typeof status === "number" && status > 0 && status < 500) {
    return false;
  }

  return firstArg instanceof Error;
}
